import React, { useState, useEffect } from 'react'
import { C_SmallBlog } from './layout'
import { C_BlogsData } from '../../constants'
import { useTranslation } from 'react-i18next'

const Related_Blogs = ({ id }) => {
    const [blogData, setBlogData] = useState([])
    
    useEffect(() => {
        setBlogData(C_BlogsData.filter(blog => blog.id !== id))
    }, [id])
    const {t} =useTranslation()
    return (
        <div className='flex flex-col items-start max-w-[25rem] gap-4'>
            <h6 className="text-light-titke dark:text-dark-title h5">{t("Related Blogs")}</h6>
            {
                blogData.map((item) => (
                    <C_SmallBlog key={item.id} blog={item} />
                ))
            }
        </div>
    )
}

export default Related_Blogs